import { useCallback } from 'react';

export function useGoogleAuth() {
  const loginWithGoogle = useCallback(() => {
    // Redirect to Google OAuth endpoint
    const backendUrl =
      import.meta.env.VITE_BACKEND_URL ||
      (process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000'
        : 'https://api.happiscreen.com');
    window.location.href = `${backendUrl}/auth/google`;
  }, []);

  return { loginWithGoogle };
}
